import styled from "styled-components";
import { Table, Typography, } from "@bracket/ui";




/**
 * EpochsCard component displays a table of epochs with their dates and estimated amounts
 * @returns {JSX.Element} A card containing a table of epoch information
 */
export const EpochsCard = () => {
	return (
		<CardContainer>
			<Typography variant="paragraphXL" color="var(--text-heading-title)">
				Epochs
			</Typography>

			<Table
				tableContainerStyle={{ padding: 0 }}
				data={[
					{
						id: 1,
						epoch: "+01",
						date: "Dec 20, 2024",
						est_amount: (
							<EstimatedAmountContainer>
								<div>Sign</div>
								<div>Value</div>
							</EstimatedAmountContainer>
						),
					},
					{
						id: 2,
						epoch: "+02",
						date: "-",
						est_amount: (
							<EstimatedAmountContainer>
								<div>Sign</div>
								<div>Value</div>
							</EstimatedAmountContainer>
						),
					},
					{
						id: 3,
						epoch: "+03",
						date: "-",
						est_amount: (
							<EstimatedAmountContainer>
								<div>Sign</div>
								<div>Value</div>
							</EstimatedAmountContainer>
						),
					},
					{
						id: 4,
						epoch: "+04",
						date: "-",
						est_amount: (
							<EstimatedAmountContainer>
								<div>Sign</div>
								<div>Value</div>
							</EstimatedAmountContainer>
						),
					},
					{
						id: 5,
						epoch: "+05",
						date: "-",
						est_amount: (
							<EstimatedAmountContainer>
								<div>Sign</div>
								<div>Value</div>
							</EstimatedAmountContainer>
						),
					},
				]}
				headerColor="var(--text-paragraph)"
				showHeaderSeparator
				showLastRowSeparator={false}
				columns={[
					{ header: "Epoch", accessor: "epoch" },
					{ header: "Date", accessor: "date" },
					{ header: "Est. Amount due (brktETH)", accessor: "est_amount" },
				]}
			/>
		</CardContainer>
	);
};



const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 24px;
	gap: 32px;
	border-radius: 8px;
	background-color: var(--surface);
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const EstimatedAmountContainer = styled.div`
	display: flex;
	gap: 12px;
`;
